import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { SITE } from "@/data/siteData";
import { CITIES } from "@/data/cities";
import { SERVICES } from "@/data/services";

export default function Footer() {
  const half = Math.ceil(CITIES.length / 2);
  const colA = CITIES.slice(0, half);
  const colB = CITIES.slice(half);

  return (
    <footer data-testid="site-footer" className="bg-[#00367e] text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="bg-white rounded-2xl p-4 inline-block mb-6">
            <img
              src={SITE.logo}
              alt="Logo Dégraissage Hotte Melun"
              width="120" height="120"
              className="h-24 w-24 object-contain"
              loading="lazy"
            />
          </div>
          <p className="text-white/85 text-[15px] leading-relaxed mb-6">
            Spécialiste du dégraissage de hottes professionnelles, nettoyage d'extraction et entretien de cuisines professionnelles à Melun et dans toute la Seine-et-Marne (77).
          </p>
          <div className="space-y-3 text-[15px]">
            <a href={`tel:${SITE.phoneTel}`} className="flex items-center gap-3 hover:text-[#066ec4] transition-colors" data-testid="footer-phone">
              <Phone size={18} className="text-[#066ec4]" /> {SITE.phoneDisplay}
            </a>
            <a href={`mailto:${SITE.email}`} className="flex items-center gap-3 hover:text-[#066ec4] transition-colors" data-testid="footer-email">
              <Mail size={18} className="text-[#066ec4]" /> {SITE.email}
            </a>
            <div className="flex items-start gap-3">
              <MapPin size={18} className="text-[#066ec4] mt-0.5" />
              <span>{SITE.address.street}<br/>{SITE.address.postalCode} {SITE.address.city}</span>
            </div>
            <div className="flex items-center gap-3">
              <Clock size={18} className="text-[#066ec4]" />
              <span className="font-semibold">Ouvert {SITE.hoursLabel}</span>
            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <h3 className="text-white font-bold text-base mb-5 uppercase tracking-wider">Services</h3>
          <ul className="space-y-2.5 text-[14.5px]">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="text-white/80 hover:text-white hover:underline">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-5">
          <h3 className="text-white font-bold text-base mb-5 uppercase tracking-wider">Zones d'intervention</h3>
          <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-[14.5px]">
            <ul className="space-y-2.5">
              {colA.map((c) => (
                <li key={c.slug}>
                  <Link to={`/${c.slug}`} className="text-white/80 hover:text-white hover:underline">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
            <ul className="space-y-2.5">
              {colB.map((c) => (
                <li key={c.slug}>
                  <Link to={`/${c.slug}`} className="text-white/80 hover:text-white hover:underline">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/15">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[13px] text-white/70">
          <div>© {new Date().getFullYear()} {SITE.legalName} — Tous droits réservés.</div>
          <div className="flex items-center gap-4">
            <Link to="/mentions-legales" className="hover:text-white">Mentions légales</Link>
            <span>·</span>
            <Link to="/contact" className="hover:text-white">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
